module.exports = {"540223100":"协格尔镇","540223101":"岗嘎镇","540223200":"加措乡","540223201":"绒辖乡","540223202":"尼辖乡","540223203":"盆吉乡","540223204":"曲当乡","540223205":"扎果乡","540223206":"扎西宗乡","540223207":"长所乡","540223208":"曲洛乡","540223209":"措果乡","540223210":"克玛乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540223.json
// module id = 2494
// module chunks = 0